module.exports = __webpack_public_path__ + "assets/profile5.4f4056de.svg";